import React from "react";
import { View, StyleSheet } from "react-native";

import CountrySelector from "./CountrySelector";
import NameSelector from "./NameSelector";
import GetStartedChecklist from "./GetStartedChecklist";

export default function CarouselSlide({
  data,
  slide,
  position,
  changeScreen = () => {},
  updateInfo = () => {},
}) {
  return (
    <View style={styles.content}>
      {/* Checklist */}
      {slide.name.indexOf("checklist") > -1 ? (
        <GetStartedChecklist
          currentStep={position == 0 ? 1 : 2}
          title={data.name ? `Nice to meet you, ${data.name}!` : "Get Started"}
        />
      ) : null}

      {/* Location */}
      {slide.name == "country" ? (
        <CountrySelector
          data={data}
          slide={slide}
          updateInfo={updateInfo}
          changeScreen={changeScreen}
        />
      ) : null}

      {/* Name */}
      {slide.name == "name" ? (
        <NameSelector
          data={data}
          slide={slide}
          updateInfo={updateInfo}
          changeScreen={changeScreen}
        />
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  content: {
    width: 400,
    maxWidth: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    //paddingTop: 30,
  },
});
